import { Checkbox } from '@mui/material';
import React, { ComponentProps, useCallback } from 'react';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';
import { MAIN_THEME } from '@styles';
import { IFormFieldInputBaseProps } from '.';

interface ICheckboxFormFieldProps extends IFormFieldInputBaseProps {
  name: string;
  checked: boolean;
  indeterminate?: boolean;
  onChange: (name: string, value: boolean) => void;
  classes?: {
    checkbox?: ComponentProps<typeof Checkbox>['classes'];
    error?: string;
    title?: string;
  };
}

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  root: {
    height: 14,
    width: 14,
    // padding: '6px 6px 6px 0',
    '& svg': {
      height: 14,
      width: 14,
      color: MAIN_THEME.color.black,
    },
  },
  title: {
    fontFamily: MAIN_THEME.font.regular,
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '16px',
    color: MAIN_THEME.color.black,
  },
  error: {
    textAlign: 'right',
    fontSize: MAIN_THEME.fontSize.xs,
    minHeight: '15px',
    display: 'block',
    color: MAIN_THEME.color.red,
    marginLeft: '32px',
  },
}));

const CheckboxFormField: React.FC<ICheckboxFormFieldProps> = ({
  name,
  title,
  checked,
  error,
  disabled,
  indeterminate,
  inputOnly,
  onChange,
  style,
  className,
  classes,
}) => {
  const checkboxClasses = useStyles().classes;

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, inputChecked: boolean) => {
      onChange(name, inputChecked);
    },
    [name, onChange]
  );

  const renderCheckbox = () => (
    <Checkbox
      color="primary"
      classes={{
        root: checkboxClasses.root,
        ...classes?.checkbox,
      }}
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      indeterminate={indeterminate}
      size="small"
    />
  );

  return inputOnly ? (
    renderCheckbox()
  ) : (
    <label htmlFor={name} className={className} style={style}>
      <div className={checkboxClasses.container}>
        {renderCheckbox()}
        <span className={clsx(checkboxClasses.title, classes?.title)}>
          {title}
        </span>
      </div>
      <span
        id={`errorMsg-${name}`}
        className={clsx(checkboxClasses.error, classes?.error)}
      >
        {error}
      </span>
    </label>
  );
};

export default CheckboxFormField;
